module.exports = __webpack_public_path__ + "static/img/apple-pay-logo.e062e61b.svg";